import httpClient from '~api/httpClient';

export type FetchQtyUpdaterConnectionUrlResponse = { url: string };

export const fetchQtyUpdaterConnectionUrl = () => {
	return httpClient.get<FetchQtyUpdaterConnectionUrlResponse>(
		'/websocket-connection/qty-updater',
	);
};
